import { Gruendungsart } from '../v2024';

export const GruendungsartLabels = {
    _1: '1' as Gruendungsart,
    _2: '2' as Gruendungsart
};

